import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-config-expanded',
  templateUrl: './config-expanded.component.html',
  styleUrls: ['./config-expanded.component.scss']
})

/**
 * this class updates the wfId and wfhId properties of the class,
 * whenever a change is detected in the data input property.
 */
export class ConfigExpandedComponent implements OnChanges {

  @Input() data: any;
  @Input() wfId: number | undefined;
  @Input() wfhId: number | undefined;
  @Input() mode: any | 'read';

  ngOnChanges(changes: SimpleChanges): void {
    this.wfId = this.data['wfId'];

    this.wfhId = this.data['wfhId'];
  }
}
